module.exports = __webpack_public_path__ + "static/media/banner_virtualsports.19f6e251.png";